import Head from 'next/head'
import sanitizeHtml from 'sanitize-html'
import { replaceAll, truncate } from '../lib/strings'

const userDescription = (user) => {
  let description = null
  if (user.bio)
    description = truncate(
      replaceAll(sanitizeHtml(user.bio, { allowedTags: [] }), '&nbsp;', ' ')
    )
  return description
}

const UserMeta = ({ user }) => {
  const description = userDescription(user)
  const title = `${user.username} on Buy Music Club`

  return (
    <Head>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {user.avatar && <meta property="og:image" content={user.avatar} />}
      <meta
        property="og:url"
        content={`https://buymusic.club/user/${user.username.toLowerCase()}`}
      />
      <meta property="twitter:title" content={title} />
      <meta name="twitter:card" content="summary_large_image" />
    </Head>
  )
}

export default UserMeta
